import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  UPDATE_TOKEN,
  TOKEN_EXPIRED,
  ERROR_NOTIFICATION,
} from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  isAuthenticated: sessionStorage.getItem("token") ? true : false,
  token: sessionStorage.getItem("token"),
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        token: null,
        message: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        token: action.token,
        message: "You have been successfully logged in.",
      };
    case TOKEN_EXPIRED:
      return {
        ...state,
        isFetching: true,
        token: null,
      };
    case UPDATE_TOKEN:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        token: action.token,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        token: null,
        message: `Authentication Error: ${action.status} ${action.statusText}`,
      };
    case ERROR_NOTIFICATION:
      return {
        ...state,
        error: action.error,
      };
    case LOGOUT:
      sessionStorage.removeItem("token");
      return {
        ...state,
        isAuthenticated: false,
        token: null,
      };
    default:
      return state;
  }
};

export default auth;
